export { fetchZipCodeInfo } from './fetch-zipcode-info'
